// components/brands/ErrorState.jsx
import React from 'react';
import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';

const ErrorState = ({ 
  isDarkMode, 
  error = "Failed to load brands. Please try again.",
  title = "Something went wrong",
  icon: Icon = FiAlertCircle,
  iconSize = 32,
  actionText = "Try Again",
  onRetry
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-10">
      {/* Icon */}
      <div className="mb-3">
        <Icon 
          size={iconSize} 
          className={isDarkMode ? 'text-red-400' : 'text-red-500'}
        />
      </div>

      {/* Title */}
      <h3 className={`text-sm font-medium mb-1 text-center ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`}>
        {title}
      </h3>

      {/* Error Message */}
      <p className={`text-xs text-center max-w-xs mb-3 ${
        isDarkMode ? 'text-gray-400' : 'text-gray-500'
      }`}>
        {error}
      </p>

      {/* Retry Button */}
      {onRetry && (
        <button
          onClick={onRetry}
          className={`px-4 py-2 text-xs font-medium rounded-lg transition-colors flex items-center gap-1.5 ${
            isDarkMode 
              ? 'bg-gray-800 text-gray-300 hover:bg-gray-700' 
              : 'bg-red-50 text-red-700 hover:bg-red-100 border border-red-200'
          }`}
        >
          <FiRefreshCw size={12} />
          <span>{actionText}</span>
        </button>
      )}
    </div>
  );
};

export default ErrorState;